import style from './stimulations.module.scss';
import { DataTable } from 'components/data-table';
import { stimulationsColumns } from './stimulations-columns';
import type { StimulationRow } from 'types/well-stimulations';
import { useSourceWellSimulations } from './hooks';

interface StimulationsProps {
  resourceHref: string;
  uwi: string;
  /** Resolves the rows as-of a workspace; omitted on the Well page. */
  workspaceId?: number;
}

export const Stimulations = ({
  uwi,
  resourceHref,
  workspaceId,
}: StimulationsProps) => {
  const {
    data,
    meta,
    loading,
    error,
    onFilterChange,
    onGlobalSearchChange,
    onPageChange,
    onSortChange,
  } = useSourceWellSimulations(uwi, resourceHref || '', workspaceId);

  return (
    <div className={style.stimulationsDetails}>
      <DataTable<StimulationRow>
        data={data}
        columns={stimulationsColumns}
        getRowId={(row) => String(row.id)}
        isLoading={loading}
        error={error}
        scroll={{
          mode: 'paginated',
          serverDriven: true,
          totalCount: meta.total,
        }}
        onFilterChange={(s) => onFilterChange(s.columnFilters)}
        onGlobalSearchChange={(s) => onGlobalSearchChange(s.globalFilter)}
        onPaginationChange={(s) => onPageChange(s.page, s.pageSize)}
        onSortChange={(s) => onSortChange(s.sorting)}
        searchPlaceholder="Search stimulations…"
        config={{
          sorting: true,
          columnResizing: true,
          columnReordering: true,
          columnPinning: true,
          columnVisibility: true,
          globalSearch: true,
          columnFilters: true,
          export: {
            exportPresets: [
              {
                name: 'Export',
                format: 'xlsx',
                filename: 'stimulations-export',
              },
            ],
          },
        }}
        initialTableState={{
          sortColumn: 'jobReportedEndDate',
          sortDirection: 'desc',
        }}
      />
    </div>
  );
};
